export default __webpack_public_path__ + "static/media/16418216968.d7e2bc7a.JPG";